import React, { PureComponent } from 'react'
import { object } from 'prop-types'
import { Table } from 'reactstrap'
import { TableLegend, TableHeader, TableCell, MinutesTableCell, HealthTableCell } from 'components'
import { translate } from 'react-i18next'
import { sortBy } from 'lodash'
import './Race.css'

@translate()
export class RaceTabDetail extends PureComponent {
    static propTypes = {
        data: object.isRequired
    }

    renderRowPlayer = ({ id, position, player, points, time, engine, gearbox, wheels }) => {
        const { t } = this.props
        return (
            <tr key={id}>
                <TableCell tag="td" className="Big text-center">{position}</TableCell>
                <TableCell tag="td" className="text-center">{player}</TableCell>
                <TableCell tag="td" className="text-center">{points}</TableCell>
                <MinutesTableCell tag="td" className="text-center">{time}</MinutesTableCell>
                <HealthTableCell tag="td" health={engine.health}>{engine.name}</HealthTableCell>
                <HealthTableCell tag="td" health={gearbox.health}>{gearbox.name}</HealthTableCell>
                <TableCell tag="td" className="Small">
                    <div>{t('game.RACE.wheels.planned')}: {wheels.planned}</div>
                    <div>{t('game.RACE.wheels.corrective')}: {wheels.corrective}</div>
                </TableCell>
            </tr>
        )
    }

    render() {
        const { data: { players = [] } = {}, t } = this.props
        return (
            <div className="RaceTabDetail h-100">
                <TableLegend
                    items={[
                        { color: 'green', text: t('game.RACE.legend.good') },
                        { color: 'yellow', text: t('game.RACE.legend.medium') },
                        { color: 'red', text: t('game.RACE.legend.critical') },
                        { color: 'black', text: t('game.RACE.legend.broken') },
                    ]}
                />
                <Table className="vertical-center">
                    <thead>
                        <tr>
                            <TableHeader tag="th" className="text-center">{t('game.RACE.tableHeaders.position')}</TableHeader>
                            <TableHeader tag="th" className="text-center">{t('game.RACE.tableHeaders.player')}</TableHeader>
                            <TableHeader tag="th" className="text-center">{t('game.RACE.tableHeaders.points')}</TableHeader>
                            <TableHeader tag="th" className="text-center">{t('game.RACE.tableHeaders.time')}</TableHeader>
                            <TableHeader tag="th">{t('game.RACE.tableHeaders.engine')}</TableHeader>
                            <TableHeader tag="th">{t('game.RACE.tableHeaders.gearbox')}</TableHeader>
                            <TableHeader tag="th">{t('game.RACE.tableHeaders.wheels')}</TableHeader>
                        </tr>
                    </thead>
                    <tbody>
                        {sortBy(players, ['position', p => -p.points]).map(this.renderRowPlayer)}
                    </tbody>
                </Table>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Phases/Race/RaceTabDetail.js